import React from 'react';
import usStates from '../../data/usStates.json';
import { Select } from './FormControls';

const StateSelect = props => {
    const {states, territories} = usStates;

    return (
        <Select {...props}>
            <option>--</option>
            <optgroup label="U.S. States">
                {states.map((state) => (
                    <option 
                        value={state.toLowerCase().replaceAll(' ', '_')}
                    >
                        {state}
                    </option>
                ))}
            </optgroup>
            <optgroup label="U.S. Territories">
                {territories.map((territory) => (
                    <option 
                        value={territory.toLowerCase().replaceAll(' ', '_')}
                    >
                        {territory}
                    </option>
                ))}
            </optgroup>
        </Select>
    )
}

export default StateSelect;